import * as Yup from 'yup';

const phoneNumberRegex = /(\+994(\s)\(\d{2})\)(\s)\d{3}(\-)\d{2}(\-)\d{2}/g;

export const useSignupSchema = (t) =>
    Yup.object().shape({
        firstName: Yup.string()
            .trim()
            .min(3, t('employerRegistration:namesMinValidation'))
            .max(25, t('employerRegistration:namesMaxValidation'))
            .matches(/^[A-ZƏÜÖİĞÇŞQI][a-zəüöiğçjşı]{2,25}$/, t('employerRegistration:namesValidation'))
            .required(t('employerRegistration:firstNameRequired')),

        lastName: Yup.string()
            .trim()
            .min(3, t('employerRegistration:namesMinValidation'))
            .max(25, t('employerRegistration:namesMaxValidation'))
            .matches(/^[A-ZƏÜÖİĞÇŞQI][a-zəüöiğçjşı]{2,25}$/, t('employerRegistration:namesValidation'))
            .required(t('employerRegistration:lastNameRequired')),

        companyName: Yup.string().required(t('employerRegistration:companyNameRequired')),
        companyRegionId: Yup.string().required('required'),
        phoneNumber: Yup.string()
            .matches(phoneNumberRegex, t('employerRegistration:phoneInvalid')) // TODO: Validate format
            .required(t('employerRegistration:phoneRequired')),
        password: Yup.string()
            .trim()
            .max(25, t('employerRegistration:passwordLength'))
            .notOneOf([Yup.ref('email')], t('employerRegistration:passwordAndEmailEqual'))
            .required(t('employerRegistration:passwordRequired')),
        email: Yup.string()
            .email(t('employerRegistration:emailInvalid'))
            .required(t('employerRegistration:emailRequired')),
    });
